<template lang="pug">
    v-card(shaped class="ma-0 pa-0")
        v-card-actions
            v-btn(icon @click="removeTrip")
                v-icon mdi-close
            span(class="swatch" :style="swatchStyle")
            v-col(cols=8)
                div.subtitle-2(v-show="!editing" @click="editing = !editing;") {{ trip.title }}
                v-text-field(dense v-show="editing" v-model="trip.title" @blur="editing = !editing" @click="startEditing")
            v-spacer
            v-btn(icon @click="show =! show")
                v-icon {{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
        v-expand-transition
            div(v-show="show" class="pa-4")
                p How often do you do this trip?
                v-row(align="baseline")
                    v-col(cols=12 sm=4)
                        v-select(":items"="amounts" v-model="trip.frequency" outlined attach)
                    v-col(cols=12 sm=4)
                        span(class="per") time{{ trip.frequency > 1 ? 's':''}} per
                    v-col(cols=12 sm=4)
                        v-select(":items"="units" v-model="trip.frequencyUnit" outlined attach)
                v-row(align="baseline")
                    v-col(cols=12) 
                        AddressFinder(:model="trip.fromAddress" :clear="true" label="Starting from")
                v-row(align="baseline" justify="center")
                    v-col(class="right spacer" cols=1)
                        v-btn(fab x-small @click="addVia(0)")
                            v-icon mdi-plus
                div(v-for="(v, index) in trip.viaAddresses" :key="v.id ? v.id : v.osm_id")
                    v-row(align="baseline")
                        v-col(cols=11) 
                            AddressFinder(:model="v" :clear="true" label="Then going to")
                        v-col(cols=1)
                            v-btn(fab x-small @click="removeVia(index)" icon tile)
                                v-icon mdi-close
                    v-row(align="center" justify="center")
                        v-col(class="right spacer" cols=1)
                            v-btn(fab x-small @click="addVia(index + 1)")
                                v-icon mdi-plus
                v-row(align="baseline")
                    v-col(cols=12) 
                        AddressFinder(:model="trip.toAddress" :clear="true" label="Ending at")
                v-row(align="baseline")
                    v-col(cols=12)
                        v-btn(@click="makeReturn" class="secondary" :disabled="!complete") Create return trip
            
</template>

<script>
import AddressFinder from "./AddressFinder.vue";
import EVNav from "../services/api/EVNav.js";
import TripCardSupport from "../mixins/TripCardSupport.js";
export default {
  props: ["trip", "expanded", "editTitle", "colour"],
  mixins:[TripCardSupport],
  data() {
    return {
      editing: this.editTitle,
      show: this.expanded,
      panel: [],
      amounts: [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31
      ],
      units: ["day", "workday", "week", "fortnight", "month", "year"],
      swatchStyle: {
        background: this.colour
      }
    };
  },
  computed: {
    complete() {
      return this.trip.fromAddress.Address != null && this.trip.toAddress.Address != null
    }
  },
  components: {
    AddressFinder
  },
  mounted() {
    this.updateTripData();
  },
  methods: {
    startEditing() {
      if (this.trip.title == "Give this trip a name") {
        this.trip.title = "";
      }
    },
    removeTrip() {
      this.$emit("remove", this.trip);
    },
    makeReturn() {
      this.$emit("makeReturn",this.trip);
    },
    tripFrequency() {
      return this.trip.frequency + " times per " + this.trip.frequencyUnit;
    },
    addVia(index) {
      this.trip.viaAddresses.splice(index, 0, {
        id: this.trip.viaAddresses.length + 1
      });
    },
    removeVia(index) {
      this.trip.viaAddresses.splice(index, 1);
    },
    updateTripData() {
      if (
        this.trip.fromAddress.Address != null &&
        this.trip.toAddress.Address != null
      ) {
        EVNav.getDirectRoute(this.trip).then(response => {
          this.trip.path = [];
          for (let c of response.routes[0].geometry.coordinates) {
            this.trip.path.push([c[1], c[0]]);
          }
          this.trip.distance = response.routes[0].distance;
          this.$emit("tripUpdated");
          return this.trip.path;
        });
      }
    }
  },
};
</script>
<style scoped>
.right {
  text-align: right;
}
.detail {
  color: #666666;
  font-size: 0.8em;
}
.per {
  font-style: italic;
  text-align: center;
  width: 100%;
  display: block;
}
.spacer {
  height: 24px;
}
.spacer * {
  position: relative;
  top: 50%;
}
.swatch {
  width: 12px;
  height: 12px;
  content: " ";
  display: block;
  background: blue;
}
</style>